import { flow } from 'fp-ts/function';
import { get, reduce, toPairs } from 'lodash/fp';

import { CurrencyValue } from '@mews-distributor/common';
import { PricingModeKey } from '@mews/enums';
import { multiplyNumbersAsDecimals } from '@mews/framework';

interface CurrencyValueAccumulator {
    data: Record<string, CurrencyValue>;
    adjustment: number;
}

const currencyValueIteratee = (
    currencyValueAccumulator: CurrencyValueAccumulator,
    [currencyCode, currencyValueObject]: [string, CurrencyValue]
) => {
    currencyValueAccumulator.data[currencyCode] = {
        ...currencyValueObject,
        [PricingModeKey.NetValue]: multiplyNumbersAsDecimals(
            get(PricingModeKey.NetValue, currencyValueObject),
            currencyValueAccumulator.adjustment
        ),
        [PricingModeKey.GrossValue]: multiplyNumbersAsDecimals(
            get(PricingModeKey.GrossValue, currencyValueObject),
            currencyValueAccumulator.adjustment
        ),
    };

    return currencyValueAccumulator;
};

export const adjustCurrencyValueByPercentage = (currencyValue: Record<string, CurrencyValue>, adjustment: number) =>
    flow(toPairs, reduce(currencyValueIteratee, { data: {}, adjustment }), get('data'))(currencyValue);
